import { z } from "zod";

import {
  AudienceDtoSchema,
  CreateAudienceDtoSchema,
} from "../../../dtos/audiences";
import {
  CreateExclusionGroupDtoSchema,
  CreateExclusionGroupOnCreateSchema,
} from "../../../dtos/exclusion-group";
import { CreateExperiencePageTargetingDtoSchema } from "../../../dtos/experience-page-targeting";
import {
  CreateExperienceProductDtoSchema,
  ExperienceProductDtoSchema,
} from "../../../dtos/experience-products";
import {
  CreateExperienceDtoSchema,
  ExperienceDtoSchema,
} from "../../../dtos/experiences";
import { OfferProductDtoSchema } from "../../../dtos/offer-products";
import { OfferDtoSchema } from "../../../dtos/offers";
import { OnsiteEditDtoSchema } from "../../../dtos/onsite-edits";
import {
  CreateOnsiteInjectionDtoSchema,
  OnsiteInjectionDtoSchema,
} from "../../../dtos/onsite-injections";
import { RedirectDtoSchema } from "../../../dtos/redirects";
import { S3FileLocationDtoSchema } from "../../../dtos/s3-file-location";
import { ShippingTestMethodDefinitionDtoSchema } from "../../../dtos/shipping-test-method-definitions";
import { CreateVariationDtoSchema } from "../../../dtos/variations";
import { CreateExclusionGroupFeSchema } from "../../../fe-only/exclusion-groups";

export const PutExperienceRequestBodySchema = z.object({
  experienceId: z.string().uuid().optional(),
  experience: CreateExperienceDtoSchema.extend({
    productsLocation: S3FileLocationDtoSchema.nullish(),
  }),
  variations: CreateVariationDtoSchema.array(),
  onsiteEdits: OnsiteEditDtoSchema.array().optional().default([]),
  onsiteInjections: CreateOnsiteInjectionDtoSchema.array()
    .optional()
    .default([]),
  redirects: RedirectDtoSchema.array().optional().default([]),
  audience: CreateAudienceDtoSchema.optional(),
  exclusionGroup: CreateExclusionGroupOnCreateSchema.optional(),
  experiencePageTargeting: CreateExperiencePageTargetingDtoSchema.array()
    .optional()
    .default([]),
  offerProducts: OfferProductDtoSchema.array().optional().default([]),
  shippingTestMethodDefinitions:
    ShippingTestMethodDefinitionDtoSchema.array().optional(),
  offers: OfferDtoSchema.array().optional().default([]),
  experienceProducts: CreateExperienceProductDtoSchema.array()
    .optional()
    .default([]),
});

export const PutExperienceParamsSchema = z.object({
  experienceId: z.string().optional(),
});

export type PutExperienceParamsType = z.infer<typeof PutExperienceParamsSchema>;

export type PutExperienceRequestBodyType = z.infer<
  typeof PutExperienceRequestBodySchema
>;

export const PutExperienceResponseBodySchema = z.object({
  experience: ExperienceDtoSchema,
});

export type PutExperienceResponseBodyType = z.infer<
  typeof PutExperienceResponseBodySchema
>;
